import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import {
  ButtonPlugin, FormCheckboxPlugin, CardPlugin, FormSelectPlugin, SpinnerPlugin, IconsPlugin, AlertPlugin, OverlayPlugin, InputGroupPlugin, FormRadioPlugin, LayoutPlugin, BadgePlugin, ListGroupPlugin, TablePlugin, TooltipPlugin, FormDatepickerPlugin, TabsPlugin,
} from 'bootstrap-vue'

Vue.use(ButtonPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(CardPlugin)
Vue.use(FormSelectPlugin)
Vue.use(SpinnerPlugin)
Vue.use(IconsPlugin)
Vue.use(AlertPlugin)
Vue.use(OverlayPlugin)
Vue.use(InputGroupPlugin)
Vue.use(FormRadioPlugin)
Vue.use(LayoutPlugin) // this registers b-container, b-row, b-col
Vue.use(BadgePlugin)
Vue.use(ListGroupPlugin)
Vue.use(TablePlugin)
Vue.use(TooltipPlugin)
Vue.use(FormDatepickerPlugin)
Vue.use(TabsPlugin)
Vue.component(FeatherIcon.name, FeatherIcon)
